import { FC, useEffect, useState } from 'react';
import { FlightSearch, PairBag } from 'ts/flight/interfaces/FlightSearch';
import { getBaggagePrice } from 'services/flight';
import { formatPrice } from 'utils/utils';
import Skeleton from 'react-loading-skeleton';
import { getBounds } from 'utils/shared/utils';
import LoadingBlock from 'components/shared/LoadingBlock';

import { useTranslation } from 'react-i18next';
import { b2b } from 'constants/generic';

interface FlightPairsBaggageProps {
  flight: FlightSearch;
  sessionStorageKey: string;
}

const FlightPairsBaggage: FC<FlightPairsBaggageProps> = ({ ...props }) => {
  const [bags, setBags] = useState<PairBag[]>();
  const [t] = useTranslation();

  useEffect(() => {
    (async () => {
      const response = await getBaggagePrice({
        searchToken: sessionStorage.getItem(props.sessionStorageKey) || '',
        id: props.flight.id,
        getFamilyPlan: false,
      });

      const strType = (val: string) => {
        const types = [
          { value: '', text: 'Main' },
          {
            value: 'BAG',
            text: 'Baggage',
          },
          {
            value: 'SPORT',
            text: 'Sport',
          },
          {
            value: 'PETS',
            text: 'Pets',
          },
          {
            value: 'UMNR',
            text: 'Handicap',
          },
          {
            value: 'BOARD',
            text: 'Boarding',
          },
        ];

        return types.find((item) => item.value === val)?.text || '';
      };

      const bounds = getBounds(response?.bookFareAndBaggage?.flights?.[0]);

      const bags = bounds.map((bound: any) => {
        const list = (bound.listOfCatalogPrice || []).reduce((acc: any, curr: any) => {
          const bagIndex = acc.findIndex((item: any) => item.type === strType(curr.type));
          if (bagIndex === -1) {
            acc.push({ type: strType(curr.type), list: [curr] });
          } else {
            acc[bagIndex].list.push(curr);
          }
          return acc;
        }, []);

        return {
          name: bound.departureAirport.cityDesc + ' -> ' + bound.arrivalAirport.cityDesc,
          bigList: list,
        };
      });

      setBags(bags.filter((bag: any) => bag.bigList.length > 0));
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.flight]);

  return (
    <div className="flex-one flex-column text-sm">
      {!bags && (
        <div className="fl-pair-bag">
          {b2b && <LoadingBlock />}
          {[...new Array(4)].map((_, index) => (
            <div key={index} className="text-lh">
              <div className="title mb-0">
                <Skeleton width={130} />
              </div>
              {[...new Array(10)].map((_, index) => (
                <div key={index} className="flex-between bb-1 pb-5 mb-5">
                  <div style={{ textTransform: 'capitalize' }}>
                    <Skeleton width={150} />
                  </div>
                  <div>
                    <Skeleton width={20} />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {bags?.map((bag, bagIndex) => (
        <div className=" fl-pair-bag" key={bagIndex}>
          <div className="fl-pair-bag-title">{bag.name}</div>
          {bag.bigList.map((item, index) => (
            <div key={index} className="text-lh">
              <div className="title mb-0">{item.type}</div>
              {item.list.map((item: any, index2: any) => (
                <div key={index2} className="flex-between bb-1 pb-5 mb-5">
                  <div style={{ textTransform: 'capitalize' }}>{item.desc?.toLowerCase()}</div>
                  <div className="text-bold text-st">
                    {formatPrice(Math.round(item.price), item.currency)}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
      {!!bags && !bags?.length && (
        <div className="text-center text-st mt-30">{t('mo.no_data_found')}</div>
      )}
    </div>
  );
};

export default FlightPairsBaggage;
